<template>
  <span v-if="text" class="o-anim-text">
    <span v-for="(word, i) in words" :key="`word-${i}`" class="o-anim-text__w">
      <span class="o-anim-text__t" v-html="filteredCopy(word)"></span>
    </span>
  </span>
</template>

<script>
export default {
  name: "AnimText",
  props: {
    text: {
      type: String
    }
  },
  computed: {
    words() {
      let words = this.text.split(" ");
      return words;
    }
  },
  methods: {
    filteredCopy(copy) {
      var filtered = copy.replace("l’", "l<span class='apostrophe-spacings-large'>’</span>");
      return filtered.replace("l'", "l<span class='apostrophe-spacings-large'>’</span>");
    }
  }
};
</script>

<style lang="scss">
.o-anim-text {
  display: flex;
  flex-wrap: wrap;
  margin-right: -0.15em;
  margin-left: -0.15em;
}

.o-anim-text__w {
  margin-right: 0.15em;
  margin-left: 0.15em;
  overflow: hidden;

  .-push & {
    overflow: visible;
  }
}

.o-anim-text__t {
  display: block;
  transition: inherit;

  .js-reveal & {
    transform: translate(0, 112%);
  }
}
</style>
